export default __webpack_public_path__ + "static/WWLFImage-d0899c941a7b77567e685674b08e5bca.png";